import type { TOC } from '@ember/component/template-only';
import { PrismIcon } from '@mylighthouse/prism-ember';
import type { IconName } from '@mylighthouse/prism-ember/types/components/prism/icon';

interface HotelBenchmarkInsightMarketCompositionMarketCompositionDetailsItemSignature {
  Args: {
    dataTestId?: string;
    fillRow?: boolean;
    iconName?: IconName;
    subTitle: string;
    title: string;
  };
}

const HotelBenchmarkInsightMarketCompositionMarketCompositionDetailsItem =
  <template>
    <div
      class="rounded-200 bg-general-neutral-50 flex w-fit items-center justify-center px-400 py-300"
    >
      {{#if @title}}
        <div
          class="details__container__section__body__item
            {{if
              @fillRow
              'details__container__section__body__item--full-width'
            }}"
          data-test-id={{@dataTestId}}
        >
          <div class="details__container__section__body__item__title">
            {{#if @iconName}}
              <div class="details__container__section__body__item__title__icon">
                <PrismIcon @name={{@iconName}} @size="small" />
              </div>
            {{/if}}

            <div class="heading-3">
              {{@title}}
            </div>
          </div>
          <p
            class="details__container__section__body__item--sub-title text-200--regular"
          >
            {{@subTitle}}
          </p>
        </div>
      {{/if}}
    </div>
  </template> satisfies TOC<HotelBenchmarkInsightMarketCompositionMarketCompositionDetailsItemSignature>;

export default HotelBenchmarkInsightMarketCompositionMarketCompositionDetailsItem;
